const e = (n) => n, t = (n) => n, i = (n) => "events" in n && typeof n.events == "object", o = (n) => "getProfileMenuItems" in n && typeof n.getProfileMenuItems == "function", s = (n) => "getRoutes" in n && typeof n.getRoutes == "function", c = (n) => "signUp" in n && typeof n.signUp == "function", u = (n) => "renderSearch" in n && typeof n.renderSearch == "function", g = (n) => "initialize" in n && typeof n.initialize == "function", f = (n) => "getHead" in n && typeof n.getHead == "function", r = (n) => "getMdxComponents" in n && typeof n.getMdxComponents == "function", a = (n) => "getIdentities" in n && typeof n.getIdentities == "function";
export {
  e as createApiIdentityPlugin,
  t as createProfileMenuPlugin,
  f as hasHead,
  a as isApiIdentityPlugin,
  c as isAuthenticationPlugin,
  i as isEventConsumerPlugin,
  r as isMdxProviderPlugin,
  s as isNavigationPlugin,
  o as isProfileMenuPlugin,
  u as isSearchPlugin,
  g as needsInitialization
};
//# sourceMappingURL=zudoku.plugins.js.map
